module.exports = __webpack_public_path__ + "static/bg_banner-58bb74c7b27fc9461de1f387f62daa8b.png";